<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold">{{ mesAnioActual }}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="space-between">
                <v-col cols="4">
                  <v-btn text @click="$refs.calendar.prev()">
                    <v-icon>mdi-arrow-left</v-icon>
                    Mes anterior
                  </v-btn>
                </v-col>
                <v-col cols="4" align="right">
                  <v-btn text @click="$refs.calendar.next()">
                    Mes siguiente
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-calendar
              ref="calendar"
              v-model="calendario"
              color="secondary"
              event-color="secondary"
              :events="calendarCursosProgramados"
              @click:event="mostrarEvento($event)"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :close-on-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card class="ui-module-card" color="primary" min-width="350px">
                <v-card-title class="ui-module-titlebar">{{ selectedEvent.name }}</v-card-title>
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold">Impartido por: {{ selectedEvent.capacitador }}</div>
                  <div class="text-subtitle-2 font-weight-bold">Aula: {{ selectedEvent.aula }}</div>
                  <div class="text-subtitle-2 font-weight-bold">
                    Fecha de finalización: {{ formatDate(selectedEvent.end) }}
                  </div>
                </v-card-text>
                <v-card-actions class="ui-module-actions">
                  <v-btn color="secondary" class="ui-module-btn-solid" @click="closeMenu()"> Cerrar </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="perfil !== PERFILES['Profesionalización'] && perfil !== PERFILES['IFCSP_PROFESIONALIZACION']">
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold"
            >Candidatos ({{ candidatos.length }} enlistados)</v-card-title
          >
          <v-card-text>
            <div v-if="candidatos.length == 0" class="text-body-1">No hay información para mostrar.</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold"
            >Aspirantes en reclutamiento ({{ preaspirantes.length }} enlistados)</v-card-title
          >
          <v-card-text>
            <div v-if="preaspirantes.length == 0" class="text-body-1">No hay información para mostrar.</div>
            <template v-else>
              <v-virtual-scroll height="480" item-height="64" :items="preaspirantes">
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.idPersonal" two-line>
                    <v-list-item-avatar>
                      <v-avatar color="secondary" size="80">
                        <v-icon color="white">mdi-account</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="text-body-1 font-weight-bold">
                          {{ getFullName(item) }}
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div class="text-body-2">{{ getAge(item.fechaNacimiento) }}</div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold"
            >Aspirantes validados ({{ aspirantes.length }} enlistados)</v-card-title
          >
          <v-card-text>
            <div v-if="aspirantes.length == 0" class="text-body-1">No hay información para mostrar.</div>
            <template v-else>
              <v-virtual-scroll height="480" item-height="64" :items="aspirantes">
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.idPersonal" two-line>
                    <v-list-item-avatar>
                      <v-avatar color="secondary" size="80">
                        <v-icon color="white">mdi-account</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="text-body-1 font-weight-bold">
                          {{ getFullName(item) }}
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <div class="text-body-2">{{ getAge(item.fechaNacimiento) }}</div>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <div class="text-body-2">
                          Resultado C3: {{ item.observacionesC3 != '' ? item.observacionesC3 : 'EN PROCESO' }}
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon small @click="openActualizaAspiranteDialog(item)"
                        ><v-icon color="secondary">mdi-file-edit</v-icon></v-btn
                      >
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <actualiza-aspirante-dialog-component
      :active="actualizaAspiranteDialog"
      :aspirante="selectedAspirante"
      @close="actualizaAspiranteDialog = false"
    ></actualiza-aspirante-dialog-component>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ActualizaAspiranteDialogComponent from '../../components/profesionalizacion/ActualizaAspiranteDialogComponent.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    ActualizaAspiranteDialogComponent,
  },

  data() {
    return {
      PERFILES,
      calendario: '',

      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,

      selectedAspirante: null,
      actualizaAspiranteDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('cursoProgramado', {
      cursosProgramados: 'getCursosProgramados',
    }),

    ...mapGetters('candidato', {
      candidatos: 'getCandidatos',
    }),

    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
      aspirantes: 'getAspirantes',
    }),

    mesAnioActual() {
      const ref = this.calendario || moment().format('YYYY-MM-DD')
      return moment(ref, 'YYYY-MM-DD')
        .locale('es')
        .format('MMMM [de] YYYY')
        .replace(/^\w/, (c) => c.toUpperCase())
    },

    calendarCursosProgramados: function () {
      var programacion = []
      var estatusPermitidos = [1, 2]

      this.cursosProgramados.forEach((cursoProgramado) => {
        const estatusCurso = Number(cursoProgramado.fkidEstatusCurso)
        if (!estatusPermitidos.includes(estatusCurso)) return

        const inicio = this.parseCursoFecha(cursoProgramado.fechaInicio)
        const fin = this.parseCursoFecha(cursoProgramado.fechaFin)

        if (inicio && fin) {
          programacion.push({
            name: 'Inicio de la capacitación: ' + cursoProgramado.Subcategoria.subcategoria,
            aula: cursoProgramado.Aula.aula,
            capacitador: this.getFullName(cursoProgramado.Capacitador),
            start: inicio.format(this.VUETIFY_DATE_FORMAT),
            end: fin.format(this.VUETIFY_DATE_FORMAT),
          })
        }
      })

      return programacion
    },
  },

  methods: {
    mostrarEvento(event) {
      this.selectedEvent = event.event
      this.selectedOpen = true
    },

    closeMenu() {
      this.selectedOpen = false
    },

    openActualizaAspiranteDialog(aspirante) {
      this.selectedAspirante = aspirante
      this.actualizaAspiranteDialog = true
    },

    formatDate(value) {
      if (!value) return ''
      return moment(value, 'YYYY-MM-DD').locale('es').format('D [de] MMMM [de] YYYY')
    },

    parseCursoFecha(value) {
      if (!value) return null
      const formats = [this.API_DATE_FORMAT, this.VUETIFY_DATE_FORMAT, 'DD/MM/YYYY', 'YYYY-MM-DD']
      const parsed = moment(value, formats, true)
      return parsed.isValid() ? parsed : null
    },
  },
}
</script>

<style scoped>
/* Título del card */
::v-deep .v-card-title {
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
  padding: 24px !important;
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.text-h6 {
  color: #26de81 !important;
}

/* Card text */
::v-deep .v-card-text {
  padding: 32px 24px !important;
  color: #e0e0e0 !important;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 24px !important;
  background: rgba(0, 210, 160, 0.05);
  border-top: 1px solid rgba(0, 210, 160, 0.1);
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn[color='secondary'],
::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(0, 210, 160, 0.4) !important;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

::v-deep .v-btn.v-btn--text {
  color: #00d2a0 !important;
}

::v-deep .v-btn.v-btn--text:hover {
  background: rgba(0, 210, 160, 0.1) !important;
}

/* Ripple effect */
::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

/* Calendario */
::v-deep .v-calendar {
  background: transparent !important;
  border-radius: 12px;
}

::v-deep .v-calendar-daily__head {
  background: rgba(0, 210, 160, 0.1) !important;
  border-bottom: 2px solid rgba(0, 210, 160, 0.3);
}

::v-deep .v-calendar-daily_head-day-label {
  color: #e0e0e0 !important;
  font-weight: 600;
}

::v-deep .v-calendar-daily__intervals-body {
  background: transparent !important;
}

/* Eventos en el calendario */
::v-deep .v-event {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  border-left: 4px solid #26de81 !important;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 210, 160, 0.3);
  color: #062118 !important;
  transition: all 0.3s ease;
}

::v-deep .v-event:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 210, 160, 0.5);
}

/* Día actual */
::v-deep .v-present {
  border: 2px solid #00d2a0 !important;
}

/* Días del calendario */
::v-deep .v-calendar-weekly__day {
  border-color: rgba(0, 210, 160, 0.1) !important;
}

::v-deep .v-calendar-weekly__day:hover {
  background: rgba(0, 210, 160, 0.05) !important;
}

::v-deep .v-calendar-weekly__day-label {
  color: #e0e0e0 !important;
}

/* Avatares */
::v-deep .v-avatar {
  background: rgba(0, 210, 160, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(0, 210, 160, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-avatar {
  transform: scale(1.1) rotate(5deg);
  border-color: #00d2a0;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.4);
}

::v-deep .v-avatar .v-icon {
  color: #26de81 !important;
  filter: drop-shadow(0 4px 12px rgba(0, 210, 160, 0.4));
}

/* Virtual Scroll */
::v-deep .v-virtual-scroll {
  background: transparent !important;
}

/* Listas */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  background: rgba(26, 46, 36, 0.4);
  border: 1px solid rgba(0, 210, 160, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-list-item:hover {
  background: rgba(0, 210, 160, 0.15);
  border-color: rgba(0, 210, 160, 0.3);
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(0, 210, 160, 0.2);
}

::v-deep .v-list-item-title {
  color: #e0e0e0 !important;
  font-weight: 600;
}

::v-deep .v-list-item-subtitle {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-list-item-action .v-btn {
  background: rgba(0, 210, 160, 0.2) !important;
  border-radius: 8px;
}

::v-deep .v-list-item-action .v-btn:hover {
  background: rgba(0, 210, 160, 0.3) !important;
  transform: scale(1.1);
}

::v-deep .v-list-item-action .v-icon {
  color: #00d2a0 !important;
}

/* Menu del evento (card flotante) */
::v-deep .v-menu__content .v-card {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
}

::v-deep .v-menu__content .v-card-title {
  color: #26de81 !important;
  font-weight: 700;
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
}

::v-deep .v-menu__content .v-card-text {
  color: #e0e0e0 !important;
}

::v-deep .v-menu__content .text-subtitle-2 {
  color: rgba(224, 224, 224, 0.85) !important;
  margin-bottom: 8px;
}

::v-deep .v-menu__content .v-card-actions {
  background: rgba(0, 210, 160, 0.05);
  border-top: 1px solid rgba(0, 210, 160, 0.1);
}

/* Textos */
.text-body-1,
.text-body-2 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  color: #26de81 !important;
}

/* Iconos */
::v-deep .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1);
}

/* Scrollbar personalizada */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}
</style>
